import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

export default function usePutVehicle() {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  useEffect(() => {
    if (isSuccess) {
      toast.success('Véhicule mis à jour avec succès.');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  const putVehicle = async (vehicleKey, vehicleData) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.put(`/vehicles/${vehicleKey}`, vehicleData);
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (response.status === 200) {
        setIsSuccess(true);
        return response.data;
      } else {
        setIsSuccess(false);
        throw new Error();
      }
    } catch (err) {
      setError(err?.message || 'Une erreur est survenue.');
      setIsSuccess(false);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setError('');
    setIsSuccess(false);
    setIsLoading(false);
  };

  return {
    error,
    isLoading,
    isSuccess,
    putVehicle,
  };
}


